import { useHttpClient } from './httpClient.js';

const resource = 'result_api_users';

export function fetchParams() {
	return useHttpClient().get(`/${resource}/params`);
}

export function create(user) {
	return useHttpClient().post(`/${resource}`, { user });
}

export function fetchUsers() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchUser(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function updateUser(id, user) {
	return useHttpClient().put(`/${resource}/${id}`, { user });
}
